import VerzamelBeschikking from './VerzamelBeschikking.js';

const addView = {
	init: function() {
		let verzamelBeschikking = new VerzamelBeschikking();
		verzamelBeschikking.init();
	}
};

export default addView;
